import { render, staticRenderFns } from "./ForumLog.vue?vue&type=template&id=2999d5d0&"
import script from "./ForumLog.vue?vue&type=script&lang=js&"
export * from "./ForumLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports